import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Freeze } from "react-freeze";
import { Box } from "@mui/material";
import useStore from "../../store";

const importTab = (component) => React.lazy(() => import("../../Tabs/" + component + "/" + component)); // eslint-disable-line
const importPluginTab = (plugin, component) => React.lazy(() => new Promise((resolve) => {
    import("../../Plugins/" + plugin + "/Tabs/" + component).then((componentPlugin) => { // eslint-disable-line
        resolve(componentPlugin);
    }).catch((e) => {
        console.error(e);
        import("../../Widgets/ComponentNotFound/ComponentNotFound").then((notFound) => {
            resolve(notFound);
        });
    });
}));

export default function Tab(props) {
    const { tab, currentTab } = props;
    const { isEditing } = props.tab;
    const handleEscapeClicked = useStore((store) => store.dashboard.handleEscapeClicked);
    const [view, setView] = React.useState(null);
    // const [freeze, setFreeze] = React.useState(false);
    const ref = React.useRef();

    React.useEffect(() => {
        // if (currentTab !== tab.id) {
        //     const timeOut = setTimeout(() => setFreeze(true), 1000);
        //     return () => {
        //         clearTimeout(timeOut);
        //     };
        // }
        ref.current?.focus();
        // setFreeze(false);
    }, [currentTab]);

    const checkKey = (e) => {
        if (e.code === "Escape") {
            handleEscapeClicked(tab.id);
        }
    };
    React.useEffect(() => {
        ref.current?.focus();
    }, [isEditing]);
    // React.useEffect(() => {
    //     if (!freeze) {
    //         ref.current?.focus();
    //     } else {
    //         ref.current?.blur();
    //     }
    // }, [freeze]);
    React.useEffect(() => {
        (async () => {
            if (!tab.plugin) {
                const ImportedTab = await importTab(tab.component);
                setView(<ImportedTab
                    tab={tab}
                />);
            } else {
                const ImportedTab = await importPluginTab(
                    tab.plugin[0].toUpperCase() + tab.plugin.slice(1),
                    tab.component,
                );

                setView(<ImportedTab
                    tab={tab}
                />);
            }
        })();
    }, []);

    return (
        // <Freeze freeze={freeze}>
        <React.Suspense fallback={(
            <FontAwesomeIcon
                mt={6}
                ml={2}
                mr={2}
                icon="spinner"
                spin
            />
        )}
        >
            <Box
                sx={{
                    outline: "none",
                    height: "100%",
                }}
                tabIndex={-1}
                onKeyDown={checkKey}
                ref={ref}
            >
                {view}
            </Box>
        </React.Suspense>
        // </Freeze>

    );
}
